(() => {
  const wrappers = document.querySelectorAll('.expandable-text');

  wrappers.forEach(wrapper => {
    const btn = wrapper.querySelector('.read-more-button');
    if (!btn) return;

    if (!btn.hasAttribute('role')) btn.setAttribute('role', 'button');
    if (!btn.hasAttribute('tabindex')) btn.setAttribute('tabindex', '0');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-label', 'Read more');
    btn.textContent = 'Read More';

    const toggle = () => {
      const expanded = wrapper.classList.toggle('more');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      btn.setAttribute('aria-label', expanded ? 'Read less' : 'Read more');
      btn.textContent = expanded ? 'Read Less' : 'Read More';
    };

    btn.addEventListener('click', toggle);

    btn.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle();
      }
    });
  });
})();
